import { Select, SelectProps } from 'antd';
import { genTestID } from '../../utils/utils';

import styles from './inputs.module.less';

interface TaggedSelectOwnProps extends SelectProps<string>{
  options:Inputs.SelectOption[]
  tag:string
}

const TaggedSelect = (props:TaggedSelectOwnProps) => {
  const { options, tag } = props;
  const { Option } = Select;

  return (
    <Select
      showSearch
      filterOption={(input, option) => option?.label?.toString().toLocaleLowerCase().indexOf(
        input.toLowerCase(),
      )! >= 0}
      data-testid={genTestID('select', tag)}
      className={styles['full-width']}
      {...props}
    >
      {options.map((option) => (
        <Option value={option.value} key={option.value}>{option.label}</Option>
      ))}
    </Select>
  );
};

export default TaggedSelect;
